import { createAction } from 'redux-actions';
import { TICKET_DISASSOCIATED } from '../constants/actionTypes';
export const ticketDisassociated = createAction(TICKET_DISASSOCIATED, ({
  threadId,
  ticketId
}) => ({
  ticketId,
  threadId
}));